import OrderList from '../components/Order/OrderList';

export default function OrderListPage() {
  return (
    <>
      <h2 className="text-2xl font-semibold mb-4 text-blue-600">Orders</h2>
      <OrderList />
    </>
  );
}